import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const MOCK_TICKETS = [
  {
    id: 'TK-2026-001234',
    title: 'System downtime error 500',
    customer: 'Acme Corp',
    status: 'Open',
    priority: 'High',
    created: '2026-04-20 10:30',
    updated: '10 mins',
    replies: 3,
  },
  {
    id: 'TK-2026-001233',
    title: 'Password reset request',
    customer: 'TechStart Inc',
    status: 'In Progress',
    priority: 'Medium',
    created: '2026-04-20 09:15',
    updated: '1 hour',
    replies: 2,
  },
  {
    id: 'TK-2026-001232',
    title: 'Email configuration issue',
    customer: 'Global Services',
    status: 'Resolved',
    priority: 'Low',
    created: '2026-04-20 08:00',
    updated: '3 hours',
    replies: 5,
  },
  {
    id: 'TK-2026-001231',
    title: 'VPN connection problem',
    customer: 'Digital Agency',
    status: 'Open',
    priority: 'High',
    created: '2026-04-19 16:45',
    updated: '1 day',
    replies: 1,
  },
  {
    id: 'TK-2026-001230',
    title: 'Database backup failed',
    customer: 'Acme Corp',
    status: 'In Progress',
    priority: 'Critical',
    created: '2026-04-19 15:30',
    updated: '1 day',
    replies: 4,
  },
];

export default function TicketListPage() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('All');
  const [filterPriority, setFilterPriority] = useState('All');

  const filteredTickets = MOCK_TICKETS.filter((ticket) => {
    const matchSearch =
      ticket.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
      ticket.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      ticket.customer.toLowerCase().includes(searchTerm.toLowerCase());

    const matchStatus =
      filterStatus === 'All' || ticket.status === filterStatus;

    const matchPriority =
      filterPriority === 'All' || ticket.priority === filterPriority;

    return matchSearch && matchStatus && matchPriority;
  });

  const getStatusColor = (status) => {
    switch (status) {
      case 'Open':
        return { bg: '#dbeafe', color: '#1e3a8a' };
      case 'In Progress':
        return { bg: '#fef3c7', color: '#92400e' };
      case 'Resolved':
        return { bg: '#dcfce7', color: '#166534' };
      default:
        return { bg: '#f3f4f6', color: '#374151' };
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'Critical':
        return '#dc2626';
      case 'High':
        return '#ea580c';
      case 'Medium':
        return '#d97706';
      case 'Low':
        return '#65a30d';
      default:
        return '#6b7280';
    }
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <header style={styles.header}>
        <div style={styles.headerContent}>
          <h1 style={styles.title}>Support Tickets</h1>
          <button
            onClick={() => alert('New ticket form coming soon')}
            style={styles.newTicketBtn}
          >
            ➕ New Ticket
          </button>
        </div>
      </header>

      {/* Filters & Search */}
      <section style={styles.filterSection}>
        <div style={styles.searchBox}>
          <input
            type="text"
            placeholder="Search by ID, title, or customer..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={styles.searchInput}
          />
        </div>

        <div style={styles.filterRow}>
          <div style={styles.filterGroup}>
            <label style={styles.filterLabel}>Status</label>
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              style={styles.filterSelect}
            >
              <option>All</option>
              <option>Open</option>
              <option>In Progress</option>
              <option>Resolved</option>
            </select>
          </div>

          <div style={styles.filterGroup}>
            <label style={styles.filterLabel}>Priority</label>
            <select
              value={filterPriority}
              onChange={(e) => setFilterPriority(e.target.value)}
              style={styles.filterSelect}
            >
              <option>All</option>
              <option>Critical</option>
              <option>High</option>
              <option>Medium</option>
              <option>Low</option>
            </select>
          </div>

          <button
            onClick={() => {
              setSearchTerm('');
              setFilterStatus('All');
              setFilterPriority('All');
            }}
            style={styles.resetBtn}
          >
            Reset
          </button>
        </div>
      </section>

      {/* Tickets List */}
      <section style={styles.content}>
        {filteredTickets.length === 0 ? (
          <div style={styles.emptyState}>
            <p style={styles.emptyIcon}>📭</p>
            <p style={styles.emptyText}>No tickets found</p>
          </div>
        ) : (
          <div style={styles.ticketTable}>
            {filteredTickets.map((ticket) => {
              const statusColor = getStatusColor(ticket.status);
              return (
                <div
                  key={ticket.id}
                  onClick={() => navigate(`/tickets/${ticket.id}`)}
                  style={styles.ticketCard}
                  role="button"
                  tabIndex={0}
                >
                  <div style={styles.ticketHeader}>
                    <div style={styles.ticketMeta}>
                      <h3 style={styles.ticketId}>{ticket.id}</h3>
                      <p style={styles.ticketTitle}>{ticket.title}</p>
                    </div>
                    <div style={styles.ticketActions}>
                      <span
                        style={{
                          ...styles.statusBadge,
                          backgroundColor: statusColor.bg,
                          color: statusColor.color,
                        }}
                      >
                        {ticket.status}
                      </span>
                    </div>
                  </div>

                  <div style={styles.ticketBody}>
                    <div style={styles.ticketInfo}>
                      <span style={styles.infoLabel}>Customer:</span>
                      <span style={styles.infoValue}>{ticket.customer}</span>
                    </div>

                    <div style={styles.ticketInfo}>
                      <span style={styles.infoLabel}>Priority:</span>
                      <span
                        style={{
                          ...styles.priorityBadge,
                          backgroundColor: getPriorityColor(ticket.priority),
                        }}
                      >
                        {ticket.priority}
                      </span>
                    </div>

                    <div style={styles.ticketInfo}>
                      <span style={styles.infoLabel}>Replies:</span>
                      <span style={styles.infoValue}>{ticket.replies}</span>
                    </div>
                  </div>

                  <div style={styles.ticketFooter}>
                    <span style={styles.timestamp}>
                      Created: {ticket.created}
                    </span>
                    <span style={styles.updated}>Updated: {ticket.updated}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #fafbfc 0%, #f0f4ff 50%, #faf8ff 100%)',
    paddingBottom: '64px',
  },

  // Header
  header: {
    background: 'linear-gradient(135deg, #ffffff 0%, #f8faff 50%, #ffffff 100%)',
    borderBottom: '2px solid rgba(30, 58, 138, 0.12)',
    padding: '1.5rem',
    boxShadow: '0 8px 32px rgba(30, 58, 138, 0.12), 0 2px 8px rgba(0, 0, 0, 0.05)',
  },
  headerContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontSize: '1.75rem',
    fontWeight: '800',
    background: 'linear-gradient(135deg, #1e3a8a 0%, #0f2847 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    margin: 0,
  },
  newTicketBtn: {
    padding: '0.75rem 1.5rem',
    background: 'linear-gradient(135deg, #f97316 0%, #f97316 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: '700',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    pointerEvents: 'auto',
    boxShadow: '0 4px 15px rgba(249, 115, 22, 0.3)',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  'newTicketBtn:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 25px rgba(249, 115, 22, 0.4)',
  },

  // Filters
  filterSection: {
    background: 'linear-gradient(135deg, #ffffff 0%, #f8faff 50%, #ffffff 100%)',
    padding: '1.5rem',
    borderBottom: '2px solid rgba(30, 58, 138, 0.12)',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
  },
  searchBox: {
    maxWidth: '1200px',
    margin: '0 auto 1rem auto',
  },
  searchInput: {
    width: '100%',
    padding: '0.875rem 1.125rem',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    fontSize: '0.95rem',
    outline: 'none',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    pointerEvents: 'auto',
    boxSizing: 'border-box',
    backgroundColor: '#ffffff',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.04)',
  },
  'searchInput:focus': {
    borderColor: '#1e3a8a',
    boxShadow: '0 0 0 3px rgba(30, 58, 138, 0.1), 0 4px 12px rgba(30, 58, 138, 0.2)',
  },
  filterRow: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    gap: '1rem',
    alignItems: 'flex-end',
  },
  filterGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.4rem',
  },
  filterLabel: {
    fontSize: '0.875rem',
    fontWeight: '600',
    color: '#374151',
  },
  filterSelect: {
    padding: '0.625rem 0.75rem',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    fontSize: '0.875rem',
    outline: 'none',
    cursor: 'pointer',
    pointerEvents: 'auto',
    minWidth: '140px',
    backgroundColor: '#f9fafb',
  },
  resetBtn: {
    padding: '0.625rem 1rem',
    backgroundColor: '#e5e7eb',
    color: '#374151',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: '600',
    transition: 'background 0.2s',
    pointerEvents: 'auto',
  },
  'resetBtn:hover': {
    backgroundColor: '#d1d5db',
  },

  // Content
  content: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '1.5rem 1rem',
  },
  emptyState: {
    textAlign: 'center',
    padding: '4rem 2rem',
  },
  emptyIcon: {
    fontSize: '3rem',
    margin: 0,
    opacity: 0.5,
  },
  emptyText: {
    fontSize: '1rem',
    color: '#9ca3af',
    margin: '1rem 0 0 0',
  },

  // Ticket Cards
  ticketTable: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  ticketCard: {
    background: 'linear-gradient(135deg, #ffffff 0%, #fafbff 100%)',
    borderRadius: '14px',
    border: '1px solid rgba(30, 58, 138, 0.1)',
    padding: '1.75rem',
    cursor: 'pointer',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    pointerEvents: 'auto',
    boxShadow: '0 4px 20px rgba(30, 58, 138, 0.08), 0 1px 3px rgba(0, 0, 0, 0.02)',
  },
  'ticketCard:hover': {
    borderColor: 'rgba(30, 58, 138, 0.25)',
    boxShadow: '0 12px 32px rgba(30, 58, 138, 0.15), 0 1px 3px rgba(0, 0, 0, 0.02)',
    transform: 'translateY(-6px)',
  },

  ticketHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '1rem',
  },
  ticketMeta: {
    flex: 1,
  },
  ticketId: {
    fontSize: '0.875rem',
    fontWeight: '700',
    color: '#1f2937',
    margin: '0 0 0.4rem 0',
  },
  ticketTitle: {
    fontSize: '1.125rem',
    fontWeight: '600',
    color: '#1f2937',
    margin: 0,
  },
  ticketActions: {
    display: 'flex',
    gap: '0.5rem',
  },
  statusBadge: {
    display: 'inline-block',
    padding: '0.375rem 0.75rem',
    borderRadius: '6px',
    fontSize: '0.75rem',
    fontWeight: '600',
  },

  ticketBody: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '1rem',
    marginBottom: '1rem',
    paddingBottom: '1rem',
    borderBottom: '1px solid #f3f4f6',
  },
  ticketInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  infoLabel: {
    fontSize: '0.75rem',
    fontWeight: '600',
    color: '#6b7280',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  infoValue: {
    fontSize: '0.875rem',
    color: '#374151',
    fontWeight: '500',
  },
  priorityBadge: {
    display: 'inline-block',
    padding: '0.25rem 0.625rem',
    borderRadius: '4px',
    fontSize: '0.75rem',
    fontWeight: '600',
    color: 'white',
  },

  ticketFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '0.75rem',
    color: '#9ca3af',
  },
  timestamp: {
    display: 'block',
  },
  updated: {
    display: 'block',
  },
};
